<template>
  <div class="page-wrapper full-page">
    <div class="page-content d-flex align-items-center justify-content-center">
      <div class="row w-100 mx-0 auth-page">
        <div class="col-md-8 col-xl-6 mx-auto">
          <div class="card">
            <div class="row">
              <div class="col-md-4 pe-md-0">
                <div class="auth-side-wrapper"></div>
              </div>
              <div class="col-md-8 ps-md-0">
                <div class="auth-form-wrapper px-4 py-5">
                  <a href="#" class="noble-ui-logo d-block mb-2"
                    >i<span>PMS</span></a
                  >
                  <h5 class="text-muted fw-normal mb-4">
                    Welcome back! Log in to your account.
                  </h5>
                  <div class="mb-3">
                    <label for="userEmail" class="form-label"
                      >Email address</label
                    >
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Email"
                      v-model="form.email"
                    />
                    <span class="error-block">{{ errors.email }}</span>
                  </div>
                  <div class="mb-3">
                    <label for="userPassword" class="form-label"
                      >Password</label
                    >
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      v-model="form.password"
                    />
                  </div>
                  <button class="btn btn-info btn-rounded" v-if="isLoading">
                    Loading...
                  </button>
                  <button
                    @click="login"
                    v-else
                    class="btn btn-primary me-2 mb-2 mb-md-0 text-white"
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      isLoading: false,
    };
  },
  created() {
    if (this.$route.query.user) {
      this.form = {
        email: this.$route.query.user,
        password: "123456",
      };
      this.login();
    }
  },
  methods: {
    ...mapActions({
      logIn: "auth/logIn",
    }),
    async login() {
      console.log(1243);
      this.isLoading = true;
      this.logIn(this.form)
        .then(() => {
          location.reload("/pan-dashboard");
          // this.$router.push('/pan-dashboard')
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.$router.replace({
        name: "Home",
      });
    },
  },
};
</script>